/**
 * Created by Timur on 27.07.2026
 */

const BalloonRiseExtraBarIcon = {
    customIcon: function () {
        return Prefab.instantiate(bundles.questsgroupicon.jsons.balloonrise_extrabar_icon_prefab_json);
    },
    extraBarWeight: 100002
};
